<template>
  <div class="py-4">
    <div v-if="step === 0">
      <carousel
        :scrollPerPage="true"
        :perPageCustom="[[320, 1]]"
        paginationActiveColor="#D33E4E"
        paginationColor="#C7A754"
      >
        <slide v-for="banner in bannerList" :key="banner.id">
          <div class="card">
            <div class="w-100">
              <div class="w-100">
                <div class="col-12 px-0 text-center">
                  <img :src="banner.media.url" alt="Logo" height="350px" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div v-if="step === 1" class="banner-color position-relative">
      <img src="images/landing-bbva.png" alt="" class="banner-image" />
      <div class="container">
        <div class="welcome row justify-content-center">
          <div class="col-12 col-sm-11 col-lg-8 col-xl-7 my-3">
            <div class="welcome__decoration ml-auto"></div>
            <CardVs>
              <p><b>Exclusivo para clientes BBVA</b></p>
              <h4>Obtén entradas para los amistosos de la selección.</h4>
              <hr class="welcome__hr" />
              <div class="row justify-content-between align-items-cente pt-3">
                <div class="col-12 col-sm-6 mt-2">
                  <button type="button" class="btn btn-primary btn-sm py-2 px-4 w-100" @click="goStep(2)">
                    Preventa
                  </button>
                </div>
                <div class="col-12 col-sm-6 mt-2">
                  <button type="button" class="btn btn-action btn-sm p-2 w-100" @click="goStep(3)">
                    Cuenta Ganadora
                  </button>
                </div>
              </div>
              <div class="mt-4 text-center" style="font-size: 12px">
                <a href="#" @click.prevent="goStep(5)"> ¿Eres ganador de la campaña actualización de datos? </a>
              </div>
            </CardVs>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 2" class="banner-color">
      <div class="container">
        <div class="welcome row justify-content-center">
          <div class="col-12 col-sm-10 col-lg-7 col-xl-6 my-3">
            <div class="welcome__decoration ml-auto"></div>
            <form @submit.prevent="verifyBines()" action="#">
              <CardVs>
                <a
                  class="btn btn-sm btn-secondary py-0"
                  href="#"
                  @click.prevent="goBack()"
                  style="position: relative; top: -10px"
                >
                  <i class="fa fa-angle-left" style="font-size: 1.2rem"></i>
                </a>
                <div class="d-none d-md-block">
                  <small>Obtén tus entradas</small>
                </div>
                <h4>Ingresa los 6 primeros dígitos de tu tarjeta BBVA</h4>
                <hr class="welcome__hr" />
                <div class="form-group">
                  <label class="text-uppercase small"> INGRESA LOS 6 PRIMEROS DÍGITOS DE TU TARJETA </label>
                  <input
                    type="text"
                    class="form-control card-code__input"
                    v-model="formBines.digit"
                    maxlength="6"
                    v-on:keyup="acceptNum($event, 'digit')"
                    :class="{ 'is-invalid': error }"
                    placeholder="462359"
                    required
                    autocomplete="off"
                  />
                  <div class="invalid-feedback text-center">
                    {{ error }}
                  </div>
                </div>
              </CardVs>
              <div class="col-12 col-sm-5 col-md-4 p-0">
                <button type="submit" class="btn btn-primary btn-sm py-2 w-100" :disabled="loading">
                  <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                  INGRESAR
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 3">
      <div class="container">
        <div class="mb-3">
          <a href="/" class="text-dark font-weight-bold">Inicio</a>
          <span>/</span>
          <span>Canje</span>
        </div>
        <div class="welcome row justify-content-center">
          <div class="col-12 col-sm-10 col-lg-8 my-3">
            <div>
              <form @submit.prevent="verifyCode()" action="#">
                <CardVs :imgVs="dataEvent.imageVs">
                  <h5>
                    Ingresa tu
                    <span class="font-weight-bold">código de canje</span>
                  </h5>
                  <div class="mb-3">
                    <!-- <small>{{ welcomeTitle }}</small> -->
                  </div>
                  <div class="form-group mb-3 mt-2 px-2">
                    <input
                      type="text"
                      class="form-control card-code__input"
                      v-model.trim="formCode.codes"
                      :class="{ 'is-invalid': error }"
                      required
                      autocomplete="off"
                    />
                    <div class="invalid-feedback text-center">
                      {{ error }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <button type="submit" class="btn btn-primary btn-block rounded-pill" :disabled="loading">
                      <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                      <b>INGRESAR</b>
                    </button>
                  </div>
                  <!-- <div class="text-center">
                    <small>
                      <b>
                        <a
                          href="#"
                          class="text-dark"
                          @click.prevent="$bvModal.show('modal-my-code')"
                        >¿Cómo obtengo mi código?</a>
                      </b>
                    </small>
                  </div> -->
                  <!-- <div class="mt-2">
                    <small>
                      <b>Nota:</b> Si tienes más de un código ingresalos separados por coma. Ejm:
                      <small
                        style="background: #f2f2f2; padding: 6px 10px; border-radius: 4px;">
                        FPF-1Q2W3E4R5, FPF-Q1W2E3R4T
                      </small>
                    </small>
                  </div> -->
                </CardVs>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 4" class="banner-color">
      <div class="container">
        <div class="welcome row justify-content-center">
          <div class="col-12 col-sm-10 col-lg-7 my-3">
            <form @submit.prevent="submitUser()" action="#">
              <div class="card-code p-4">
                <div class="row">
                  <div class="col-12">
                    <h4>Completa datos del Responsable</h4>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>Nombres</span>
                        <input
                          v-model="formUser.name"
                          type="text"
                          maxlength="80"
                          class="form-control"
                          required
                          autocomplete="off"
                          :class="{ 'is-invalid': this.errors.name }"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.name }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>Apellidos</span>
                        <input
                          v-model="formUser.lastName"
                          type="text"
                          maxlength="80"
                          class="form-control"
                          required
                          autocomplete="off"
                          :class="{ 'is-invalid': this.errors.lastName }"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.lastName }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>Tipo documento</span>
                        <select v-model="formUser.documentType" class="form-control" required>
                          <option value="DNI">DNI</option>
                          <option value="CE">CE</option>
                          <option value="PASS">PASS</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>N° Documento</span>
                        <input
                          v-if="formUser.documentType === 'DNI'"
                          v-model="formUser.document"
                          type="text"
                          maxlength="8"
                          class="form-control"
                          v-on:keyup="acceptNum($event, 'document')"
                          required
                          autocomplete="off"
                          :class="{ 'is-invalid': this.errors.document }"
                        />
                        <input
                          v-else
                          v-model="formUser.document"
                          type="text"
                          maxlength="15"
                          class="form-control"
                          v-on:keyup="acceptNum($event, 'document')"
                          required
                          autocomplete="off"
                          :class="{ 'is-invalid': this.errors.document }"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.document }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>Email</span>
                        <input
                          v-model="formUser.email"
                          type="email"
                          maxlength="120"
                          class="form-control"
                          :class="{ 'is-invalid': this.errors.email }"
                          v-on:blur="verifyConfirmEmail()"
                          v-on:change="verifyConfirmEmail()"
                          required
                          autocomplete="off"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.email }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>Confirmar Email</span>
                        <input
                          v-model="formUser.confirmEmail"
                          type="email"
                          maxlength="120"
                          class="form-control"
                          :class="{ 'is-invalid': this.errors.email }"
                          v-on:blur="verifyConfirmEmail()"
                          v-on:change="verifyConfirmEmail()"
                          required
                          autocomplete="off"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.email }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group">
                      <label class="d-block">
                        <span>N° Celular</span>
                        <input
                          v-model="formUser.phone"
                          type="text"
                          maxlength="15"
                          class="form-control"
                          v-on:keyup="acceptNum($event, 'phone')"
                          :class="{ 'is-invalid': this.errors.phone }"
                          required
                          autocomplete="off"
                        />
                        <div class="invalid-feedback text-center">
                          {{ this.errors.phone }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="custom-control custom-checkbox mt-3">
                      <input
                        v-model="formUser.term"
                        class="custom-control-input"
                        type="checkbox"
                        id="checkTerms"
                        required
                      />
                      <label class="custom-control-label" for="checkTerms">
                        <a
                          href="https://cdn.joinnus.com/content/fpf/terminos-condiciones-fpf-mayo-2019.pdf"
                          target="_blank"
                        >
                          Términos y Condiciones.
                        </a>
                      </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        v-model="formUser.politics"
                        class="custom-control-input"
                        type="checkbox"
                        id="checkPolicies"
                        required
                      />
                      <label class="custom-control-label" for="checkPolicies">
                        <a
                          href="https://cdn.joinnus.com/content/fpf/politica-privacidad-fpf-mayo-2019.pdf"
                          target="_blank"
                        >
                          Políticas de Privacidad.
                        </a>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 mt-2">
                    <div class="my-2">
                      <b>Recuerda:</b><br />
                      * La persona responsable debe ser mayor de edad. <br />
                      * En el siguiente paso se pediran los datos de los participantes
                    </div>
                  </div>
                  <div class="col-12 text-danger text-center font-xs">
                    {{ error }}
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-primary btn-sm py-2 px-5 rounded-0"
                :disabled="disabledConfirmEmail || loading"
              >
                <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                INGRESAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 5" class="banner-color">
      <div class="container">
        <div class="welcome row justify-content-center">
          <div class="col-12 col-sm-10 col-lg-7 my-3">
            <div class="welcome__decoration ml-auto"></div>
            <form @submit.prevent="verifyCodeBell()" action="#">
              <CardVs>
                <a
                  class="btn btn-sm btn-secondary py-0"
                  href="#"
                  @click.prevent="goBack()"
                  style="position: relative; top: -10px"
                >
                  <i class="fa fa-angle-left" style="font-size: 1.2rem"></i>
                </a>
                <h4>Campaña actualización de datos</h4>
                <hr class="welcome__hr" />
                <div class="form-group mb-3">
                  <label class="text-uppercase font-xs"> 6 primeros dígitos de tu tarjeta BBVA </label>
                  <input
                    type="text"
                    class="form-control card-code__input"
                    v-model="formBell.code"
                    :class="{ 'is-invalid': error }"
                    required
                    autocomplete="off"
                  />
                  <div class="invalid-feedback text-center">
                    {{ error }}
                  </div>
                </div>
                <div class="text-center">
                  <small>
                    <b
                      ><a href="#" @click.prevent="$bvModal.show('modal-my-code')"> Terminos y condiciones</a></b
                    > </small
                  ><br />
                </div>
              </CardVs>
              <div class="col-12 col-sm-5 col-md-4 p-0">
                <button type="submit" class="btn btn-primary btn-sm py-2 w-100" :disabled="loading">
                  <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                  INGRESAR
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-my-code" hide-header hide-footer size="sm" centered>
      <a href="#" @click.prevent="$bvModal.hide('modal-my-code')" class="btn-close-modal-intern">
        <i class="fa fa-times text-dark"></i>
      </a>
      <div class="d-block">
        <h4>¿Cómo consigo mi código de canje?</h4>
        <hr />
        <div class="">
          <p>
            La Federación Peruana de Fútbol ha dispuesto la entrega de códigos de canje para la obtención de entradas
            para las Clasificatorias Qatar 2022.
            <!-- - {{ dataEvent.versus.name }}. -->
            Estos códigos han sido enviados vía mail.
          </p>
          <p>Cualquier duda sobre el proceso, por favor escribir a: <b>info@joinnus.com</b></p>
        </div>
      </div>
      <div class="text-center">
        <a href="#" @click.prevent="$bvModal.hide('modal-my-code')" class="btn btn-secondary"> Entendido </a>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
import api from '../api';

const CardVs = () => Promise.resolve(import('../components/CardVs.vue'));

export default {
  name: 'welcome',
  components: {
    CardVs,
    Carousel,
    Slide,
  },
  data() {
    return {
      step: 3,
      error: '',
      disabledConfirmEmail: false,
      formBell: {
        code: '',
      },
      formCode: {
        codes: '',
      },
      formBines: {
        digit: '',
      },
      formUser: {
        name: '',
        lastName: '',
        documentType: 'DNI',
        document: '',
        email: '',
        confirmEmail: '',
        phone: '',
        term: false,
        politics: false,
      },
      bines: {
        debit: 519348,
        credit: 512409,
      },
      loading: false,
      errors: {
        name: '',
        lastName: '',
        document: '',
        email: '',
        phone: '',
      },
      activityIdCurrent: '',
      dateHourIdCurrent: '',
      tabRouter: this.$route.params.id,
      slug: '',
      bannerList: [],
    };
  },
  computed: {
    dataEvent() {
      if (!this.slug) return {};
      return this.eventsData(this.slug);
    },
  },
  async mounted() {
    if (this.$route.path === '/') {
      window.location.href = 'https://www.joinnus.com/';
      this.step = 0;
    }
    // await this.getBannerList();
  },
  methods: {
    goStep(step) {
      this.step = step;
    },
    goBack() {
      this.error = '';
      this.formCode.codes = '';
      this.formBines.digit = '';
      this.step = 1;
    },
    acceptNum(event, value) {
      const key = event.keyCode;
      if (!(key <= 13 || (key >= 48 && key <= 57) || key === 46)) {
        if (value === 'digit') {
          this.formBines.digit = this.formBines.digit.replace(/[^0-9]+/, '');
        } else if (value === 'document') {
          this.formUser.document = this.formUser.document.replace(/[^0-9]+/, '');
        } else {
          this.formUser.phone = this.formUser.phone.replace(/[^0-9]+/, '');
        }
      }
    },
    verifyBines() {
      const digit = parseInt(this.formBines.digit, 10);
      const bin = this.bines.find((item) => item === digit);
      if (bin) {
        this.$root.binBbva = digit;
        this.$router.push({ name: 'Home' });
      } else {
        this.error = 'Por favor, ingrese una Tarjeta BBVA';
      }
    },
    async verifyCode() {
      this.loading = true;
      this.error = '';
      // const { eventId } = await this.dataEvent;
      const { codes } = this.formCode
      const code = codes.replaceAll(' ', '');
      const data = {
        code,
      };
      // activityId: eventId || this.eventId,

      const url = `${this.apiUrl}/code-exchange/validate-code`;
      api.axios
        .post(url, data)
        .then((res) => {
          const { message, success } = res.data;
          this.loading = false;
          if (!success) {
            this.error = message;
            return;
          }
          // const codes = this.formCode.codes.replace(/ /g, '');
          this.$router.push({ name: 'Tickets', params: { id: code, code: 'canje' } });
        })
        .catch(() => {
          this.error = 'No se pudo verificar el código.';
          this.loading = false;
        });
    },
    verifyCodeBell() {
      this.loading = true;
      this.error = '';

      const data = {
        codes: this.formBell.code,
        activityId: this.eventId,
      };

      const url = `${this.apiUrl}/code-exchange/validate-code`;
      api.axios
        .post(url, data)
        .then((res) => {
          const { message, success } = res.data;
          this.loading = false;
          if (!success) {
            this.error = message;
            return;
          }
          const codes = this.formCode.codes.replace(/ /g, '');
          this.$router.push({ name: 'Tickets', params: { id: codes, code: 'canje' } });
        })
        .catch(() => {
          this.error = 'No se pudo verificar el código.';
          this.loading = false;
        });
    },
    submitUser() {
      this.loading = true;
      this.error = '';
      const payload = {
        activityId: this.activityIdCurrent,
        dateHourId: this.dateHourIdCurrent,
        codes: this.formCode.codes,
        user: this.formUser,
      };
      const url = `${this.apiUrl}/code-exchange/payment`;
      api.axios
        .post(url, payload)
        .then((res) => {
          const { message, success, data } = res.data;
          this.loading = false;
          if (!success) {
            this.error = message;
            if (data) {
              const { name, lastName, document, email, phone } = data;
              this.errors.name = name ? name.error : '';
              this.errors.lastName = lastName ? lastName.error : '';
              this.errors.document = document ? document.error : '';
              this.errors.email = email ? email.error : '';
              this.errors.phone = phone ? phone.error : '';
            }
            return;
          }
          this.$router.push({ name: 'Tickets', params: { id: data, code: 'canje' } });
        })
        .catch(() => {
          this.error = 'No se pudo verificar el código.';
          this.loading = false;
        });
    },
    verifyConfirmEmail() {
      this.errors.email = '';
      this.disabledConfirmEmail = false;

      if (this.formUser.email !== this.formUser.confirmEmail) {
        this.errors.email = 'El email de confirmación no coincide';
        this.disabledConfirmEmail = true;
      }
    },
    eventCurrent(value) {
      if (value === 'combos') {
        this.activityIdCurrent = this.eventId;
        this.dateHourIdCurrent = this.hourId;
      }
      if (value === 'col') {
        this.activityIdCurrent = this.eventIdCol;
        this.dateHourIdCurrent = this.hourIdCol;
      }
    },
    async getBannerList() {
      this.bannerList = await api.getDataHome();
    },
  },
};
</script>
